import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { RatingScale, RatingType } from '@ruby-labs/ui-core-kit';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useLocalStorage } from 'hooks/use-local-storage.hook';
import { useSaveAnswers } from 'hooks/use-save-answers.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';

export const FeelFailureRating = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: LocalStorageKeys[RoutePath.FeelFailureRating],
        defaultValue: '',
    });

    const { pageConfiguration } = useContext(BaseContext);

    const handleClick = (rating: RatingType) => {
        saveAnswers({
            key: 'feel-failure-rating',
            itemQuestion: { question: `${t('feel-failure-rating-title')} - ${t('feel-failure-rating-subtitle')}`, value: rating.value },
        });
        setPageValue(rating.value);

        pageConfiguration.handleOnPageComplete(rating.value);
    };

    return (
        <>
            <Typography variant={TypographyVariants.h1} typographyNext={true}>
                {t('feel-failure-rating-title')}
            </Typography>
            <Typography variant={TypographyVariants.h2}>
                {t('feel-failure-rating-subtitle')}
            </Typography>

            <RatingScale
                value={pageValue}
                handleClick={handleClick}
                ratingGradationInfo={[t('rating-scale-default-gradation-disagree'), t('rating-scale-default-gradation-agree')]}
            />
        </>
    );
};
